module.exports = __webpack_public_path__ + "static/media/kintosol.38b2a4c8.jpg";